import { useIntl } from 'react-intl';

import { useAppConfigContext } from '~/contexts/AppConfig';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Select } from '~/eds/src/components/Select/Select';
import { Nullable } from '~/types/Nullable';

import { WorkflowQuestionFormField } from './types';

export const BooleanWorkflowQuestion = ({
  question,
  onChange,
  ...rest
}: WorkflowQuestionFormField<Nullable<boolean>>) => {
  const { isPanelEnlarged } = useAppConfigContext();
  const intl = useIntl();
  const {
    field: { value },
  } = question;
  const BOOLEAN_OPTIONS = [
    {
      label: intl.formatMessage({
        id: 'BooleanWorkflowQuestion.yes',
        defaultMessage: 'Yes',
        description:
          'Label for the yes option in a boolean question on the intake form',
      }),
      value: true,
    },
    {
      label: intl.formatMessage({
        id: 'BooleanWorkflowQuestion.no',
        defaultMessage: 'No',
        description:
          'Label for the no option in a boolean question on the intake form',
      }),
      value: false,
    },
  ];

  return (
    <Layout direction="column" spacing={2}>
      <FormField
        {...rest}
        input={Select}
        value={value.value ?? null}
        onChange={(val: Nullable<boolean>) => onChange(val, 'value')}
        inputProps={{
          options: BOOLEAN_OPTIONS,
          isMulti: false,
          enablePortal: true,
          width: isPanelEnlarged ? 'input.l.width' : '100%',
        }}
      />
    </Layout>
  );
};
